import src from './src/empty.vue';
import locale from '@hui-pro/locale';
import zhCN from '@hui-pro/empty/lang/zh_CN';
import Svg, { Components as SvgComponents } from './src/assets/svg.common.js';

const install = function(Vue) {
  locale.use(zhCN);
  Vue.component(src.name, src);
  Vue.use(Svg);
};

export default {
  install
};

export const Components = SvgComponents;
